// Storage keys for demo
export enum StorageKey {
  AIBotAutoEnabled = 'AIBotAutoEnabled'
}

